(function($){	
        jQuery('#customer-review-slider').owlCarousel({
            margin: 0,
            loop:true,
		 	slideSpeed : 300,
			paginationSpeed : 400,
			nav:true,
			pagination:true,  
			dots: false,
			navText: [
                "<img src='https://cdn.shopify.com/s/files/1/0694/3182/0478/files/left-slider-arrow.png?v=1740141261' alt='Previous'>", "<img src='https://cdn.shopify.com/s/files/1/0694/3182/0478/files/right-slider-arrow.png?v=1740141272' alt='Next'>" ],
            responsive: {
                0:{
	            items:1
				},
				480:{
					items:1
				},
				768:{
					items:1
				},
				1000:{
					items:2
				},
				1100:{
					items:3
				}
            }

        });
	}) (jQuery);

 jQuery(document).ready(function(){
  jQuery(".tab-btn").click(function(){
    var id_tab = jQuery(this).attr("data-val");

    // Remove 'active' class from all tab buttons and add to the clicked one
    jQuery(".tab-btn").removeClass("active");
    jQuery(this).addClass("active");
    
    // Remove 'active' class from all tab bodies and add to the target one
    jQuery(".product-tab-body").removeClass("active");
    jQuery(".product-tab-body." + id_tab).addClass("active");
  });
});


// How We Test Tabbing Section Js Start

document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".tab-btn");
  const contents = document.querySelectorAll(".tab-content");

  tabs.forEach(tab => {
    tab.addEventListener("click", () => {
      tabs.forEach(btn => btn.classList.remove("active"));
      contents.forEach(content => content.classList.remove("active"));

      tab.classList.add("active");
      document.getElementById(tab.dataset.tab).classList.add("active");
    });
  });
});

// How We Test Tabbing Section Js End

